import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bulk-actions',
  templateUrl: './bulk-actions.component.html',
  styleUrls: ['./bulk-actions.component.css']
})
export class BulkActionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
